/** @format */

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, retry, throwError } from 'rxjs';

import { CompareProductDetails } from '../interfaces/compare-product.interface';
import { Environment } from '@shared/data-access/interfaces';
import { HttpService } from '@shared/data-access/services';
import { Injectable } from '@angular/core';
import { MediaType } from '@shared/data-access/enums';

@Injectable({
	providedIn: 'root'
})
export class CompareDao {
	constructor(
		private readonly httpService: HttpService,
		private readonly environment: Environment,
		private readonly http: HttpClient
	) {}

	getProductDetails(
		ecodes: string[],
		isClearance = false,
		retries = 1
	): Observable<CompareProductDetails> {
		let httpRequestParams = new HttpParams();

		httpRequestParams = httpRequestParams
			.set('partnumbers', ecodes.join(','))
			.set('clearance', isClearance);

		let httpHeaders = new HttpHeaders({
			Accept: MediaType.APPLICATION_JSON
		});

		// Get Origin Host Header
		const origin = this.httpService.getRequestHeaderValueAndSetStateKey('ORIGIN_HOST');
		if (origin) {
			httpHeaders = httpHeaders.set('Origin', origin);
		}

		const httpOptions = {
			httpHeaders,
			params: httpRequestParams,
			withCredentials: false
		};

		return this.http
			.get<CompareProductDetails>(`${this.environment.api.compare}`, httpOptions)
			.pipe(
				catchError((error) => throwError(() => error)),
				retry(retries)
			);
	}
}
